import React from 'react';
import PropTypes from 'prop-types';

const Cross = ({
  width = 10,
  height = 10,
  className = '',
  fill = '#3C3835',
  style = {},
}) => (
  <div className={`la-icon icon-svg-cross ${className}`} style={style}>
    <svg width={width} height={height} viewBox="10 10 10 10">
      <path
        fill={fill}
        id="a"
        d="M15.941 14.25h3.75v1.5h-3.75v3.75h-1.5v-3.75h-3.75v-1.5h3.75V10.5h1.5v3.75z"
      />
    </svg>
  </div>
);

Cross.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
};

export default Cross;
